import { render } from "./AltaUsuariosPage.vue?vue&type=template&id=0b995f4c"
import script from "./AltaUsuariosPage.vue?vue&type=script&lang=js"
export * from "./AltaUsuariosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__